module.exports = __webpack_public_path__ + "img/fire-flame-curved.5ee98dd6.svg";